export function createInitialIssue(account) {
    return {
        name: account.fullname ?? '',
        email: account.email ?? '',
        title: '',
        description: '',
        choose_device_ids: [],
        confirm_email: false,
    };
}
